import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { StudyGroupModalService } from '../../modals/study_groups_modal_service';
import { StudyGroupMembersQuery } from '../../queries/study_group_members_query';
import { StudyGroupsQuery } from '../../queries/study_groups_query';
import { StudyGroupsEmailServant } from '../../servants/study_groups_email_servant';
import { ICourseSection, IStudyGroupMember } from '../../study_group_interfaces';
import { StudyGroupsCapabilityConfiguration } from '../../study_groups_configuration';

export class StudyGroupMembersController {
  private __section: ICourseSection;
  private isLoading: boolean = true;
  private filteredBuddies: IStudyGroupMember[];
  private searchStudent: string;
  private hasSearchResults: boolean = false;
  private shouldAutoFocus: boolean = false;
  private updateSearchStudent: () => void;

  constructor(
    private $stateParams: ng.ui.IStateParamsService,
    private $state: ng.ui.IStateService,
    private ngStudyGroupMembersQuery: StudyGroupMembersQuery,
    private ngStudyGroupsQuery: StudyGroupsQuery,
    private loadStudyGroupMembersCommand: ICommand,
    private ngStudyGroupsCapabilityConfiguration: StudyGroupsCapabilityConfiguration,
    private ngStudyGroupsEmailServant: StudyGroupsEmailServant,
    private ngStudyGroupModalService: StudyGroupModalService,
    private deleteUserFromStudyGroupCommand: ICommand,
    private selectUserCommand: ICommand,
    private clearAllSelectedUsersCommand: ICommand,
    private selectAllUsersCommand: ICommand,
    private log: any
  ) {
    this.updateSection();
    if (this.section && this.section.id) {
      this.loadStudyGroupMembersCommand(this.section.id).then(() => {
        this.isLoading = false;
        this.filteredBuddies = this.ngStudyGroupMembersQuery.result.buddies;
      });
    }
    this.updateSearchStudent = this.filterBuddies.bind(this);
  }

  get section() {
    return this.__section;
  }

  updateSection() {
    this.__section = _4.find(this.ngStudyGroupsQuery.result.allSections, {
      id: parseInt(this.$stateParams.sectionId, 10)
    });
  }

  joined() {
    this.updateSection();
  }

  selectBuddy(buddy: any) {
    this.selectUserCommand(buddy.id);
  }

  selectAll() {
    return this.selectAllUsersCommand();
  }

  filterBuddies(value: string) {
    this.hasSearchResults = !_4.isEmpty(value);
    this.searchStudent = value;
    this.filteredBuddies = _4.filter(this.ngStudyGroupMembersQuery.result.buddies, (buddy: IStudyGroupMember) =>
      _4.includes(_4.toLower(buddy.name), _4.toLower(this.searchStudent))
    );
  }

  clearSelection(): void {
    this.clearAllSelectedUsersCommand();
  }

  changeSelection(): void {
    this.ngStudyGroupMembersQuery.result.isAllUsersSelected ? this.clearSelection() : this.selectAll();
  }

  leaveStudyGroup(): void {
    this.ngStudyGroupModalService.showBusySpinner = true;
    this.deleteUserFromStudyGroupCommand(this.section.id).then(() => {
      this.ngStudyGroupModalService.showBusySpinner = false;
      this.ngStudyGroupModalService.hide();
      this.$state.go('my.studyGroups');
    });
  }

  confirmRemoving(): void {
    this.ngStudyGroupModalService.show({
      heading: 'Remove from Group?',
      prompt: 'Are you sure you want to remove yourself from the',
      className: ` ${this.section.courseTitle}-${this.section.cd} Study Buddies group?`,
      cancelButtonText: `Nevermind`,
      confirmButtonText: `Yes, Leave`,
      invertButtonStyles: true,
      confirmationCallBack: this.leaveStudyGroup.bind(this)
    });
  }

  showEmailingModal(sectionInfo: ICourseSection): void {
    if (this.ngStudyGroupMembersQuery.result.selectedBuddiesCount > 0) {
      this.ngStudyGroupModalService.showEmailingModal(this.__section);
    } else {
      this.ngStudyGroupModalService.generateNoneSelectedNotification();
      this.log.user.issue('Please select at least one student from the list to email.');
    }
  }
  hideEmailingModal(): void {
    this.ngStudyGroupModalService.hideEmailingModal();
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-study-groups/src/views/study_group_members/study_group_members_controller.ts